module.exports = {

	/**
	 * Gets the name.
	 *
	 * @return     {string}  The name.
	 */
	getName() {
		return "УниКредит Булбанк";
	},

	/**
	 * Gets the company full name.
	 *
	 * @return     {string}  The company name.
	 */
	getCompanyName() {
		return "Уникредит Кънсюмър Файненсинг ЕАД";
	},

	/**
	 * Gets the logo.
	 *
	 * @return     {string}  The logo.
	 */
	getLogo() {
		return "images/logos/unicredit.png";
	},

	/**
	 * Gets the agreement file.
	 *
	 * @return     {string}  The agreement file.
	 */
	getAgreementFile() {
		return "docs/SAGLASIE-DEKLARACIQ-ZA-SAIT_ONLINE.pdf";
	},

	/**
	 * Return the summary text.
	 *
     * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * 
     * @return     	string  The summary text.
	 */

	 summary(months, price) {
		return "<p>Вие избрахте покупка на изплащане с <strong>" + this.getCompanyName() + "</strong>. Обща стойност за плащане: <strong>" + this.total(months, price).toFixed(2) + "</strong> лв., " + months + " месечни вноски по <strong>" + this.perMonth(months, price).toFixed(2) + "</strong> лв.</p><p>Кредитните условия на " + this.getCompanyName() + " включват <a href='/" + this.getAgreementFile() + "' target='_blank'><strong>Декларация за съгласие за обработка на лични данни</strong></a>, с която потвърждавате, че сте съгласни личните Ви данни да бъдат обработвани от " + this.getCompanyName() + " по описания в документа начин и за целите, посочени в него.</p>";
	},

	/**
	 * Return available periods
	 *
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	availablePeriods(price) {
		var coefficents = {
			3 : 34.56,
			6 : 17.75,
			9 : 12.15,
			12: 9.33,
			15: 7.66,
			18: 6.55,
			24: 5.16,
			36: 3.77
        };

		return coefficents;
	},

	/**
	 * Return total price for leasing based on given months period
	 *
	 * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	total(months, price)
	{
		return this.perMonth(months, price) * months;
	},

	/**
	 * Returns per month price for leasing based on given months period
	 *
	 * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	perMonth(months, price) 
	{
        // The key is the months period and the value is the coefficent in %
        var coefficents = this.availablePeriods(price);

        // Формула за изчисляване на вноските: цена Х коефициент = месечна вноска
		if (typeof coefficents[months] !== "undefined") {
            return price * (coefficents[months] / 100);
		}
		
		// throw new "Undefined Leasing Period for UniCredit";
		return null;
    }


}